import { render, staticRenderFns } from "./SentRecipients.vue?vue&type=template&id=f73fd65a"
import script from "./SentRecipients.vue?vue&type=script&lang=js"
export * from "./SentRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports